<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('reports.salesReport')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="sales-report">
      <div class="row mar-bt-15 report-toolbar">
        <div class="col-md-12">
          <div class="filters-applied-row">
            <el-button type="primary" size="small" @click="openFiltersModal" style="margin-right: 10px;">
              {{$t('orders.filters')}}
            </el-button>
            <template v-if="appliedFilters.length">
              <span class="filters-applied-label">{{$t('orders.filtersList')}}:</span>
              <span
                v-for="(flt, idx) in appliedFilters"
                :key="'sales-filter-' + idx"
                class="filter-selection">
                {{flt}}
              </span>
              <a href="#" @click.prevent="resetFilters()" class="reset-filters-link">{{$t('orders.resetFilters')}}</a>
            </template>
            <template v-else>
              <span class="filters-applied-label">{{$t('orders.noFiltersApplied')}}</span>
            </template>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="sales-date-row">
          <el-date-picker
            class="sales-date-picker"
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>

          <span class="sales-date-text">{{$t('general.from')}}</span>
          <div class="sales-time-range">
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              v-model="valid_from"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            <span class="sales-date-text">{{$t('general.to')}}</span>
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              v-model="valid_to"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>

          <select
            class="form-control sales-date-column"
            v-model="date_column"
            style="width: auto; min-width: 140px; margin-left: 10px; margin-right: 10px; height: 40px;">
            <option value="created_at">{{$t('reports.dateColumnCreate')}}</option>
            <option value="closed_at">{{$t('reports.dateColumnClose')}}</option>
            <option value="fiscalized_at">{{$t('reports.dateColumnFiscalize')}}</option>
          </select>

          <div class="pull-left search-button-reports">
            <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
          </div>
          <div class="search-button-reports pull-left" :title="$t('reports.export')" style="margin-bottom: 0 !important;">
            <download-excel
              v-if="this.$route.query && this.$route.query.ver !== 'V2'"
              class="btn btn-icon btn-xls-slim"
              :fetch="clientsExportData"
              :export-fields="json_fields"
              :name="export_name"
              :before-generate="startDownload"
              :before-finish="finishDownload">
              {{$t('general.download_xls') }} <img src="/static/img/export_xls.png">
            </download-excel>
            <download-excel
              v-if="this.$route.query && this.$route.query.ver === 'V2'"
              class="btn btn-icon btn-xls-slim btn-success"
              :fetch="clientsExportData"
              :fields="jsonFields"
              :name="export_name"
              :before-generate="startDownload"
              :before-finish="finishDownload">
              <i class="ti-download"></i>
            </download-excel>
          </div>
        </div>
      </div>

      <!-- Summary cards -->
      <div class="row mar-bt-15 summary-cards-row">
        <div class="col-md-4 col-sm-6">
          <div class="sales-summary-card primary">
            <div class="sales-summary-title">{{$t('reports.totalSum')}}</div>
            <div class="sales-summary-total">{{formatMoneyAmount((totals.total || 0).toFixed(2))}}</div>
            <div class="sales-summary-list">
                <div class="sales-summary-item">
                  <span>{{$t('reports.ordersNumber')}}</span>
                  <span>{{totalOrders || 0}}</span>
                </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.giftCardsSoldTotal')}}</span>
                <span>{{totals.giftCardsSoldCount || 0}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('orders.totals_discount')}}</span>
                <span>{{formatMoneyAmount((totals.totalDiscountItems || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('orders.totals_discount_loyalty_points')}}</span>
                <span>{{formatMoneyAmount((totals.totalDiscountLoyaltyPoints || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.totalTax')}}</span>
                <span>{{formatMoneyAmount((totals.totalTax || 0).toFixed(2))}}</span>
              </div>
              <div v-if="totals.totalSlotTax" class="sales-summary-item">
                <span>&nbsp;&nbsp;{{$t('reports.slotTax')}}</span>
                <span>{{formatMoneyAmount((totals.totalSlotTax || 0).toFixed(2))}}</span>
              </div>
              <div v-if="totals.totalSlotPartTax" class="sales-summary-item">
                <span>&nbsp;&nbsp;{{$t('reports.slotPartTax')}}</span>
                <span>{{formatMoneyAmount((totals.totalSlotPartTax || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.shipping')}}</span>
                <span>{{formatMoneyAmount((totals.totalShipping || 0).toFixed(2))}}</span>
              </div>
              <template v-if="use_tips">
                <div class="sales-summary-item">
                  <span>{{$t('reports.tips')}}</span>
                  <span>{{formatMoneyAmount((totals.totalTips || 0).toFixed(2))}}</span>
                </div>
              </template>
              <div class="sales-summary-item">
                <span>{{$t('reports.splitVoucher')}}</span>
                <span>{{formatMoneyAmount((totals.totalSplitVoucher || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.woltOtherMethods')}}</span>
                <span>{{formatMoneyAmount((totals.totalWoltOtherMethods || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.giftCardsSoldAmount')}}</span>
                <span>{{formatMoneyAmount((totals.giftCardsSoldAmount || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.totalPayFromWallet')}}</span>
                <span>{{formatMoneyAmount((totals.totalPayFromWallet || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.unpaid')}}</span>
                <span>{{formatMoneyAmount((totals.totalUnpaid || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.unfiscalTotal')}}</span>
                <span>{{formatMoneyAmount((totals.unfiscalTotal || 0).toFixed(2))}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="sales-summary-card">
            <div class="sales-summary-title">{{$t('reports.totalCash')}}</div>
            <div class="sales-summary-total">
              {{formatMoneyAmount((cashSummaryTotal || 0).toFixed(2))}}
            </div>
            <div class="sales-summary-list">
              <div class="sales-summary-item">
                <span>{{$t('reports.cash')}}</span>
                <span>{{formatMoneyAmount((totals.totalCash || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.glovoCash')}}</span>
                <span>{{formatMoneyAmount((totals.totalGlovoCash || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.boltCash')}}</span>
                <span>{{formatMoneyAmount((totals.totalBoltCash || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.woltCash')}}</span>
                <span>{{formatMoneyAmount((totals.totalWoltCash || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.splitCash')}}</span>
                <span>{{formatMoneyAmount((totals.totalSplitCash || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.unfiscalCash')}}</span>
                <span>{{formatMoneyAmount((totals.unfiscalTotalCash || 0).toFixed(2))}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="sales-summary-card">
            <div class="sales-summary-title">{{$t('reports.totalOnline')}}</div>
            <div class="sales-summary-total">
              {{formatMoneyAmount((totalOnlineSummaryTotal || 0).toFixed(2))}}
            </div>
            <div class="sales-summary-list">
              <div class="sales-summary-item">
                <span>{{$t('reports.card')}}</span>
                <span>{{formatMoneyAmount((totals.totalCard || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.online')}}</span>
                <span>{{formatMoneyAmount((totals.totalOnline || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.unfiscalOnline')}}</span>
                <span>{{formatMoneyAmount((totals.unfiscalTotalOnline || 0).toFixed(2))}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mar-bt-15 summary-cards-row">
        <div class="col-md-4 col-sm-6">
          <div class="sales-summary-card">
            <div class="sales-summary-title">{{$t('reports.totalCard')}}</div>
            <div class="sales-summary-total">{{formatMoneyAmount((totalCardSummaryTotal || 0).toFixed(2))}}</div>
            <div class="sales-summary-list">
              <div class="sales-summary-item">
                <span>{{$t('reports.pos')}}</span>
                <span>{{formatMoneyAmount((totals.totalPOS || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.cardPos')}}</span>
                <span>{{formatMoneyAmount((totals.totalCARDPOS || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.splitCardPos')}}</span>
                <span>{{formatMoneyAmount((totals.totalSplitCard || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.unfiscalCard')}}</span>
                <span>{{formatMoneyAmount((totals.unfiscalTotalCard || 0).toFixed(2))}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="sales-summary-card">
            <div class="sales-summary-title">{{$t('reports.totalCredit')}}</div>
            <div class="sales-summary-total">{{formatMoneyAmount((totalCreditSummaryTotal || 0).toFixed(2))}}</div>
            <div class="sales-summary-list">
              <div class="sales-summary-item">
                <span>{{$t('reports.boltCard')}}</span>
                <span>{{formatMoneyAmount((totals.totalBoltCard || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.glovoCard')}}</span>
                <span>{{formatMoneyAmount((totals.totalGlovoCard || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.woltCard')}}</span>
                <span>{{formatMoneyAmount((totals.totalWoltCard || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.unfiscalCredit')}}</span>
                <span>{{formatMoneyAmount((totals.unfiscalTotalCredit || 0).toFixed(2))}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6">
          <div class="sales-summary-card">
            <div class="sales-summary-title">{{$t('reports.totalNonFiscal')}}</div>
            <div class="sales-summary-total">{{formatMoneyAmount((nonFiscalSummaryTotal || 0).toFixed(2))}}</div>
            <div class="sales-summary-list">
              <div class="sales-summary-item">
                <span>{{$t('reports.protocol')}}</span>
                <span>{{formatMoneyAmount((totals.totalProtocol || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.staffFood')}}</span>
                <span>{{formatMoneyAmount((totals.totalStaffFood || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.virament')}}</span>
                <span>{{formatMoneyAmount((totals.totalVirament || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.room')}}</span>
                <span>{{formatMoneyAmount((totals.totalRoom || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.event')}}</span>
                <span>{{formatMoneyAmount((totals.totalEvent || 0).toFixed(2))}}</span>
              </div>
              <div class="sales-summary-item">
                <span>{{$t('reports.folio')}}</span>
                <span>{{formatMoneyAmount((totals.totalFolio || 0).toFixed(2))}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-content total-pagination reports-center-columns" v-loading="(loading && !isFiltersModalOpen) || exportLoading">
            <data-tables-server
              @query-change="paginationChanged"
              @row-click="goToRecordOrder"
              :data="ordersTableData.data"
              :search-def="{show: false}"
              :total="totalOrders"
              :pagination-props="paginationProps"
              class="report-sales"
              key="sales-table"
              style="width: 100%"
              ref="reportsTable">
              <el-table-column class-name="centered-cell" :min-width="140" prop="id" :label="$t('reports.orderId')" />
              <el-table-column class-name="centered-cell" :min-width="200" prop="location" :label="$t('reports.location')">
                <template slot-scope="props">
                  {{ getLocationName(props.row.store_id) }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" :min-width="140" prop="created_at" :label="$t('reports.date')" />
              <el-table-column class-name="centered-cell" :min-width="140" prop="updated_at" :label="$t('reports.closingOrder')" />
              <el-table-column class-name="centered-cell" :min-width="100" prop="token" :label="'# '+$t('reports.order')" />
              <el-table-column class-name="centered-cell" :min-width="100" prop="number" :label="$t('reports.number')" />
              <el-table-column class-name="centered-cell" :min-width="120" prop="table_number" :label="$t('reports.tableNumber')" >
                <template slot-scope="props">
                  {{ props.row.table_number ? props.row.table_number : '-' }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" :min-width="150" :label="$t('reports.name')">
                <template slot-scope="props">
                  {{ props.row.customer.firstname }} {{ props.row.customer.lastname }}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="120"
                class-name="centered-cell"
                prop="totals_grandtotal"
                :label="$t('reports.totalSum')">
                <template slot-scope="props">
                  {{formatMoneyAmount(props.row.totals_grandtotal)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                class-name="centered-cell"
                :label="$t('reports.discount')">
                <template slot-scope="props">
                  {{formatMoneyAmount(props.row.totals_discount + props.row.totals_discount_loyalty_points)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="120"
                class-name="centered-cell"
                :label="$t('reports.couponCode')">
                <template slot-scope="props">
                  {{props.row.coupon}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                class-name="centered-cell"
                :label="$t('reports.tax')">
                <template slot-scope="props">
                  {{formatMoneyAmount(props.row.totals_extras)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                class-name="centered-cell"
                :label="$t('reports.shipping')">
                <template slot-scope="props">
                  {{formatMoneyAmount(props.row.totals_shipping || 0)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="130"
                class-name="centered-cell"
                :label="$t('reports.delivery_type')">
                <template slot-scope="props">
                  {{$t('settingCompany.'+ props.row.delivery_type.toLowerCase())}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="130"
                class-name="centered-cell"
                :label="$t('reports.zone')">
                <template slot-scope="props">
                  <span v-if="props.row.shipping_details && props.row.shipping_details.hasOwnProperty('name')">{{props.row.shipping_details.name}}</span>
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" :min-width="130" prop="payment_type" :label="$t('reports.paymentType')">
                <template slot-scope="props">
                  {{ $t('paymentTypes.' + props.row.payment_type) }}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="140"
                class-name="centered-cell"
                :label="$t('reports.receiptNumber')">
                <template slot-scope="props">
                  {{ formatReceiptNumber(props.row.receipt_number) }}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="120"
                class-name="centered-cell"
                :label="$t('reports.zet')">
                <template slot-scope="props">
                  {{ parseZet(props.row.receipt_number) }}
                </template>
              </el-table-column>
            </data-tables-server>
          </div>
        </div>
      </div>
    </div>
      <!-- Same filter modal shell as Orders.vue (filtersAndSortModal; footer inside modal-body) -->
      <vmodal name="salesReportFiltersModal" height="auto" width="1200" :adaptive="true" :scrollable="true" class="filtersAndSortModal sales-report-filters">
        <div class="card">
          <div class="card-content">
            <div class="modal-header slim-header">
              <h4>{{$t('orders.filters')}}</h4>
            </div>
            <div class="modal-body slim-body">
              <div class="filters-grid sales-report-filters-grid">
                <div class="modal-column-left">
                  <div class="filter-section" v-if="showLocations">
                    <h6>{{$t('dashboard.selectLocation')}}</h6>
                    <select class="form-control" v-model="modalOrders.location">
                      <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
                      <option v-for="loc in locations" :key="'loc-' + loc.id" :label="loc.name" :value="loc.id">{{loc.name}}</option>
                    </select>
                  </div>

                  <div class="filter-section">
                    <h6>{{$t('reports.taxation')}}</h6>
                    <v-select
                      v-model="modalHasReceipt"
                      :options="receiptOptions"
                      label="label"
                      :placeholder="$t('general.all')"
                      class="w-100 white line-heigth-44"
                      :key="'has-receipt-select-modal'"
                    />
                  </div>

                  <div class="filter-section">
                    <h6>{{$t('reports.zet')}}</h6>
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      :placeholder="$t('reports.zet')"
                      v-model="modalZet">
                  </div>

              <div class="filter-section wide-filter" v-if="showMethods">
                <h6>{{$t('dashboard.selectMethod')}}</h6>
                <el-select
                  v-model="modalOrders.methods"
                  multiple
                  collapse-tags
                  clearable
                  filterable
                  style="width: 100%;"
                  class="w-100">
                  <el-option
                    v-for="m in methods"
                    :key="m.key || m"
                    :label="m.label || m"
                    :value="m.key || m">
                  </el-option>
                </el-select>
              </div>
                  <div class="filter-section">
                    <h6>{{$t('dashboard.selectClient')}}</h6>
                    <el-select
                      v-model="modalSelectedUser"
                      ref="userSelect"
                      filterable
                      remote
                      reserve-keyword
                      clearable
                      :placeholder="$t('general.search')"
                      :remote-method="searchUsers"
                      :loading="loadingUsers"
                      style="width: 100%;"
                      class="w-100"
                    @change="handleUserChange">
                      <el-option
                        :value="''"
                        :label="$t('general.alls')">
                      </el-option>
                      <el-option
                        v-for="usr in mergedUsers"
                        :key="'usr-' + usr.id"
                        :label="(usr.firstname && usr.lastname) ? (usr.firstname + ' ' + usr.lastname) : (usr.email || '')"
                        :value="usr.id">
                      </el-option>
                    </el-select>
                  </div>

                  <div class="filter-section" v-if="posUsers.length">
                    <h6>{{$t('reports.operator')}}</h6>
                    <select class="form-control" v-model="modalSelectedPosUser">
                      <option value="" selected :label="$t('general.alls')">{{$t('general.alls')}}</option>
                      <option v-for="operator in posUsers" :key="'op-' + operator.id" :label="operator.firstname + ' ' + operator.lastname" :value="operator.id">
                        {{operator.firstname}} {{operator.lastname}}
                      </option>
                    </select>
                  </div>

                  <div class="filter-section">
                    <h6 style="margin-bottom: 0;">{{$t('pages.topCategory')}}</h6>
                    <el-select
                      v-model="modalSelectedCategories"
                      ref="categorySelect"
                      value-key="id"
                      multiple
                      filterable
                      remote
                      collapse-tags
                      reserve-keyword
                      clearable
                      :placeholder="$t('general.search')"
                      :remote-method="searchTopCategories"
                      :loading="loadingCategories"
                      style="width: 100%"
                      class="w-100"
                      @change="clearCategorySearch">
                      <el-option
                        v-for="item in mergedCategories"
                        :key="item.id"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div>

                </div>

                <div class="modal-column-right">
                  <div class="filter-section" v-if="orderFormFlags.length">
                    <h6>{{$t('dashboard.selectedOrderFormFlags')}}</h6>
                    <select class="form-control" v-model="modalSelectedOrderFrom">
                      <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
                      <option v-for="sts in orderFormFlags" :key="'of-' + sts" :label="sts.toUpperCase()" :value="sts">{{sts}}</option>
                    </select>
                  </div>

              <div class="filter-section wide-filter" v-if="paymentMethods.length">
                <h6>{{$t('dashboard.selectedPaymentMethods')}}</h6>
                <el-select
                  v-model="modalSelectedPaymentMethods"
                  multiple
                  collapse-tags
                  clearable
                  class="w-100">
                  <el-option
                    v-for="pm in paymentMethods"
                    :key="pm.id"
                    :label="pm.name"
                    :value="pm.id">
                  </el-option>
                </el-select>
              </div>

              <div class="filter-section">
                <h6>{{$t('reports.orderPaidStatus')}}</h6>
                <select class="form-control" v-model="modalUnpaidOrdersFilter">
                  <option
                    v-for="opt in unpaidOrdersFilterOptions"
                    :key="'unpaid-filter-' + opt.value"
                    :value="opt.value">
                    {{ opt.label }}
                  </option>
                </select>
              </div>

              <div class="filter-section wide-filter">
                <h6>{{$t('reports.tables')}}</h6>
                <el-select
                  v-model="modalSelectedTable"
                  ref="salesReportTableSelect"
                  value-key="id"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  class="w-100"
                  :placeholder="$t('settingTable.searchTable')"
                  :remote-method="searchTables"
                  :loading="loadingTables"
                  @change="clearTableSearch">
                  <el-option
                    v-for="item in mergedSalesReportTables"
                    :key="item.id"
                    :label="item.label"
                    :value="item">
                  </el-option>
                </el-select>
              </div>

              <div class="filter-section" v-if="drivers.length">
                <h6>{{$t('dashboard.selectDriver')}}</h6>
                <select class="form-control" v-model="modalSelectedDriver">
                  <option value="" selected :label="$t('general.alls')">{{$t('general.alls')}}</option>
                  <option
                    v-for="drive in drivers"
                    :key="'drv-' + drive.id"
                    :label="drive.firstname + ' ' + drive.lastname"
                    :value="drive.id">
                    {{drive.firstname}} {{drive.lastname}}
                  </option>
                </select>
              </div>

                  <div class="filter-section">
                    <h6>{{$t('dashboard.serchCoupon')}}</h6>
                    <input type="text" :placeholder="$t('dashboard.serchCoupon')" class="form-control" v-model="modalOrders.search">
                  </div>

                  <div class="filter-section">
                    <h6>{{$t('general.orderId')}}</h6>
                    <input type="number" min="0" name="price" placeholder="3823231" v-model="modalOrderId" class="form-control">
                  </div>

                  <!-- <div class="filter-section">
                    <h6>{{$t('general.search')}}</h6>
                    <el-input v-model="modalFreeSearch" :placeholder="$t('reports.salesReportSearch')" class="sm-search"></el-input>
                  </div> -->
                </div>
              </div>

              <div class="modal-footer slim-footer">
                <el-button type="default" size="small" @click="resetModalFilters">{{$t('general.reset')}}</el-button>
                <el-button type="primary" size="small" @click="applyFilters">{{$t('general.apply')}}</el-button>
              </div>
            </div>
          </div>
        </div>
      </vmodal>
    </div>
  <!-- END Sales Report -->
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
import moment from 'moment'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    // GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isReports: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isReports () {
      if (this.isReports) {
        this.getOrders()
      }
    }
  },
  created () {
    const currentDate = new Date()
    const formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear()
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '-' + formattedDate + '.xls'
    this.getPaymentMethods()
    this.verifyUserLocations()
    this.verifyUserMethods()
    this.getPosUsers()
    this.getDrivers()
    this.getUsers()
    this.loadFiltersFromCookie()
  },
  beforeDestroy () {
    // Clear any pending search timeout
    if (this.userSearchTimeout) {
      clearTimeout(this.userSearchTimeout)
      this.userSearchTimeout = null
    }
  },
  data () {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      products_valid_from: '00:00',
      products_valid_to: '23:59',
      drivers: [],
      posUsers: [],
      users: [],
      topCategories: [],
      loadingCategories: false,
      loadingUsers: false,
      userSearchTimeout: null,
      orderFormFlags: this.getOrderFormFlags(),
      paymentMethods: [],
      receiptOptions: [
        { label: this.$t('reports.withoutReceipt'), value: 1 },
        { label: this.$t('reports.withReceipt'), value: 2 }
      ],
      selectedDriver: '',
      freeSearch: '',
      selectedPosUser: '',
      selected_user: '',
      selected_user_name: '',
      orderId: null,
      zet: null,
      selectedCategories: [],
      selected_order_from: '',
      selected_payment_methods: [],
      /** paid → unpaid_orders 0 (payment_type not null); unpaid → 1 (null) */
      unpaidOrdersFilter: 'paid',
      selectedTable: null,
      availableTables: [],
      loadingTables: false,
      loading: true,
      exportLoading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        // 'valid': [  // luna curenta
        //   moment().date(1).format('YYYY-MM-DD'),
        //   moment().endOf('month').format('YYYY-MM-DD')
        // ],
        valid: [
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: '',
        methods: []
      },
      date_column: 'created_at',
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: {},
      totals: {
        total: 0,
        totalCash: 0,
        totalVirament: 0,
        totalOnline: 0,
        totalProtocol: 0,
        totalStaffFood: 0,
        totalRoom: 0,
        totalEvent: 0,
        totalFolio: 0,
        totalSplit: 0,
        totalCard: 0,
        totalPOS: 0,
        totalCARDPOS: 0,
        totalTips: 0,
        totalDiscount: 0,
        totalDiscountItems: 0,
        totalDiscountLoyaltyPoints: 0,
        totalTax: 0,
        totalSlotTax: 0,
        totalSlotPartTax: 0,
        totalShipping: 0,
        avarageOrderValue: 0,
        totalPayFromWallet: 0,
        totalBoltCard: 0,
        totalBoltCash: 0,
        totalGlovoCard: 0,
        totalGlovoCash: 0,
        totalWoltCard: 0,
        totalWoltCash: 0,
        totalWoltOtherMethods: 0,
        totalSplitCash: 0,
        totalSplitCard: 0,
        totalSplitVoucher: 0,
        totalUnpaid: 0,
        unfiscalTotal: 0,
        unfiscalTotalCard: 0,
        unfiscalTotalCash: 0,
        unfiscalTotalCredit: 0,
        unfiscalTotalOnline: 0,
        giftCardsSoldCount: 0,
        giftCardsSoldAmount: 0
      },
      cardTotals: {
        total_amount: 0,
        total_cash: 0,
        total_online: 0,
        total_card: 0,
        total_credit: 0,
        total_other_methods: 0
      },
      totalOrders: null,
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      jsonFields: {
        [this.$t('reports.orderId')]: 'id',
        [this.$t('reports.location')]: 'location',
        [this.$t('reports.date')]: 'date',
        [this.$t('reports.closingOrder')]: 'updated_at',
        [this.$t('reports.order')]: 'order',
        [this.$t('reports.number')]: 'number',
        [this.$t('reports.tableNumber')]: 'table_number',
        [this.$t('reports.delivery_type')]: 'deliveryType',
        [this.$t('reports.name')]: 'name',
        [this.$t('reports.phone')]: 'phone',
        [this.$t('reports.totalAmount')]: 'totalAmount',
        [this.$t('reports.totalDiscount')]: 'totalDiscount',
        [this.$t('reports.totalTax')]: 'totalTax',
        [this.$t('reports.shipping')]: 'shipping',
        [this.$t('reports.zone')]: 'zone',
        [this.$t('reports.paymentType')]: 'paymentType',
        [this.$t('reports.orderProducts')]: 'orderProducts',
        [this.$t('reports.orderAdress')]: 'orderAdress',
        [this.$t('reports.orderComments')]: 'orderComments'
      },
      export_name: 'Export Raport Vanzari - ',
      json_fields: {
        'Id': 'id',
        'Location': 'location',
        'Date': 'date',
        'Closing Order': 'updated_at',
        '# Order': 'order',
        'Number': 'number',
        'Table Number': 'table_number',
        'Delivery Type': 'deliveryType',
        'Customer Name': 'name',
        'Phone': 'phone',
        'Total': 'totalAmount',
        'Discount': 'totalDiscount',
        'Taxes': 'totalTax',
        'Livrare': 'totalDelivery',
        'Zone': 'zone',
        'Payment Type': 'paymentType',
        'Ordered products': 'orderProducts',
        'Ordered adress': 'orderAdress',
        'Ordered comments': 'orderComments',
        'Receipt number': 'receiptNumber'
      },
      json_data: [],
      // use_tips: this.$session.get('tips_use')
      use_tips: true,
      hasRceipt: null,

      // Filters modal state (copied pattern from Orders.vue)
      modalOrders: {
        valid: [
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        search: '',
        methods: []
      },
      modalValidFrom: null,
      modalValidTo: null,
      modalSelectedDriver: '',
      modalSelectedPosUser: '',
      modalSelectedUser: '',
      modalSelectedUserName: '',
      modalSelectedOrderFrom: '',
      modalSelectedPaymentMethods: [],
      modalUnpaidOrdersFilter: 'paid',
      modalSelectedTable: null,
      modalOrderId: null,
      modalHasReceipt: null,
      modalFreeSearch: '',
      modalZet: null,
      modalSelectedCategories: [],

      isFiltersModalOpen: false
    }
  },
  computed: {
    appliedFilters () {
      const out = []
      if (this.orders && this.orders.location) {
        const loc = (this.locations || []).find(l => String(l.id) === String(this.orders.location))
        out.push(`${this.$t('reports.location')}: ${loc ? loc.name : this.orders.location}`)
      }
      if (this.hasRceipt && this.hasRceipt.label) {
        out.push(`${this.$t('reports.taxation')}: ${this.hasRceipt.label}`)
      }
      if (this.orders && Array.isArray(this.orders.methods) && this.orders.methods.length) {
        const labels = this.orders.methods
          .map(key => {
            const m = (this.methods || []).find(x => String(x.key || x) === String(key))
            return m ? (m.label || key) : key
          })
          .filter(Boolean)
        out.push(`${this.$t('dashboard.selectMethod')}: ${labels.join(', ')}`)
      }
      if (this.selected_user) {
        const userName = this.getSelectedUserDisplayName(this.selected_user, this.selected_user_name)
        out.push(`${this.$t('dashboard.selectClient')}: ${userName}`)
      }
      if (this.selectedPosUser) {
        const op = (this.posUsers || []).find(x => String(x.id) === String(this.selectedPosUser))
        out.push(`${this.$t('reports.operator')}: ${op ? (op.firstname + ' ' + op.lastname) : this.selectedPosUser}`)
      }
      if (this.selected_order_from) out.push(`${this.$t('dashboard.selectedOrderFormFlags')}: ${String(this.selected_order_from).toUpperCase()}`)
      if (this.selected_payment_methods && Array.isArray(this.selected_payment_methods) && this.selected_payment_methods.length) {
        const names = this.selected_payment_methods.map(id => {
          const pm = (this.paymentMethods || []).find(x => String(x.id) === String(id))
          return pm ? pm.name : id
        })
        out.push(`${this.$t('dashboard.selectedPaymentMethods')}: ${names.join(', ')}`)
      }
      if (!this.isUnpaidSelected()) {
        if (this.unpaidOrdersFilter === 'unpaid') {
          out.push(`${this.$t('reports.orderPaidStatus')}: ${this.$t('reports.unpaid')}`)
        } else if (this.unpaidOrdersFilter === 'all') {
          out.push(`${this.$t('reports.orderPaidStatus')}: ${this.$t('general.all')}`)
        }
      }
      if (this.orders && this.orders.search) out.push(`${this.$t('reports.couponCode')}: ${this.orders.search}`)
      if (this.orderId) out.push(`${this.$t('general.orderId')}: ${this.orderId}`)
      if (this.zet) out.push(`${this.$t('reports.zet')}: ${this.zet}`)
      if (this.selectedCategories && Array.isArray(this.selectedCategories) && this.selectedCategories.length) {
        const names = this.selectedCategories.map(cat => {
          if (typeof cat === 'object' && cat !== null) {
            return cat.label
          }
          // If it's just an ID, try to find it in topCategories
          const found = (this.topCategories || []).find(x => String(x.id) === String(cat))
          return found ? found.label : cat
        })
        out.push(`${this.$t('pages.topCategory')}: ${names.join(', ')}`)
      }
      if (this.selectedDriver) {
        const d = (this.drivers || []).find(x => String(x.id) === String(this.selectedDriver))
        out.push(`${this.$t('dashboard.selectDriver')}: ${d ? (d.firstname + ' ' + d.lastname) : this.selectedDriver}`)
      }
      if (this.freeSearch) out.push(`${this.$t('general.search')}: ${this.freeSearch}`)
      if (this.selectedTable && this.selectedTable.id != null) {
        const label = this.selectedTable.label || String(this.selectedTable.id)
        out.push(`${this.$t('reports.tables')}: ${label}`)
      }

      // date range is always set; show it only if it isn't "today/today" with 05:00-05:00 defaults
      const isDefaultDate = this.orders && this.orders.valid &&
        this.orders.valid[0] === moment().format('YYYY-MM-DD') &&
        this.orders.valid[1] === moment().format('YYYY-MM-DD') &&
        this.valid_from === '05:00' && this.valid_to === '05:00'
      if (!isDefaultDate && this.orders && this.orders.valid) {
        out.push(`${this.$t('reports.date')}: ${this.orders.valid[0]} ${this.valid_from} - ${this.orders.valid[1]} ${this.valid_to}`)
      }

      return out
    },
    cashSummaryTotal () {
      // Calculate fallback sum first
      const fallbackSum = (this.totals.totalCash || 0) +
        (this.totals.totalGlovoCash || 0) +
        (this.totals.totalBoltCash || 0) +
        (this.totals.totalWoltCash || 0) +
        (this.totals.totalSplitCash || 0)

      // Use cardTotals if it exists and has a value, or if fallback is 0 (to allow API to return 0)
      if (this.cardTotals && this.cardTotals.total_cash !== undefined && this.cardTotals.total_cash !== null) {
        // If API returned 0 but we have non-zero breakdown, use fallback
        if (this.cardTotals.total_cash === 0 && fallbackSum > 0) {
          return fallbackSum
        }
        return this.cardTotals.total_cash
      }
      // Fallback: calculate from individual payment types
      return fallbackSum
    },
    cardSummaryTotal () {
      // Calculate fallback sum first
      const fallbackSum = (this.totals.totalCard || 0) +
        (this.totals.totalPOS || 0) +
        (this.totals.totalCARDPOS || 0) +
        (this.totals.totalSplitCard || 0)

      // Use cardTotals if it exists and has a value, or if fallback is 0 (to allow API to return 0)
      if (this.cardTotals && this.cardTotals.total_card !== undefined && this.cardTotals.total_card !== null) {
        // If API returned 0 but we have non-zero breakdown, use fallback
        if (this.cardTotals.total_card === 0 && fallbackSum > 0) {
          return fallbackSum
        }
        return this.cardTotals.total_card
      }
      // Fallback: calculate from individual payment types
      return fallbackSum
    },
    totalOnlineSummaryTotal () {
      // Calculate fallback sum first
      const fallbackSum = (this.totals.totalCard || 0) + (this.totals.totalOnline || 0)

      // Use cardTotals if it exists and has a value, or if fallback is 0 (to allow API to return 0)
      if (this.cardTotals && this.cardTotals.total_online !== undefined && this.cardTotals.total_online !== null) {
        // If API returned 0 but we have non-zero breakdown, use fallback
        if (this.cardTotals.total_online === 0 && fallbackSum > 0) {
          return fallbackSum
        }
        return this.cardTotals.total_online
      }
      // Fallback: calculate from individual payment types
      return fallbackSum
    },
    totalCardSummaryTotal () {
      // Calculate fallback sum first
      const fallbackSum = (this.totals.totalPOS || 0) + (this.totals.totalCARDPOS || 0) + (this.totals.totalSplitCard || 0)

      // Use cardTotals if it exists and has a value, or if fallback is 0 (to allow API to return 0)
      if (this.cardTotals && this.cardTotals.total_card !== undefined && this.cardTotals.total_card !== null) {
        // If API returned 0 but we have non-zero breakdown, use fallback
        if (this.cardTotals.total_card === 0 && fallbackSum > 0) {
          return fallbackSum
        }
        return this.cardTotals.total_card
      }
      // Fallback: calculate from individual payment types
      return fallbackSum
    },
    totalCreditSummaryTotal () {
      // Calculate fallback sum first
      const fallbackSum = (this.totals.totalBoltCard || 0) + (this.totals.totalGlovoCard || 0) + (this.totals.totalWoltCard || 0)

      // Use cardTotals if it exists and has a value, or if fallback is 0 (to allow API to return 0)
      if (this.cardTotals && this.cardTotals.total_credit !== undefined && this.cardTotals.total_credit !== null) {
        // If API returned 0 but we have non-zero breakdown, use fallback
        if (this.cardTotals.total_credit === 0 && fallbackSum > 0) {
          return fallbackSum
        }
        return this.cardTotals.total_credit
      }
      // Fallback: calculate from individual payment types
      return fallbackSum
    },
    nonFiscalSummaryTotal () {
      // Calculate fallback sum first
      const fallbackSum = (this.totals.totalProtocol || 0) +
        (this.totals.totalStaffFood || 0) +
        (this.totals.totalVirament || 0) +
        (this.totals.totalRoom || 0) +
        (this.totals.totalEvent || 0) +
        (this.totals.totalFolio || 0)

      // Use cardTotals if it exists and has a value, or if fallback is 0 (to allow API to return 0)
      if (this.cardTotals && this.cardTotals.total_other_methods !== undefined && this.cardTotals.total_other_methods !== null) {
        // If API returned 0 but we have non-zero breakdown, use fallback
        if (this.cardTotals.total_other_methods === 0 && fallbackSum > 0) {
          return fallbackSum
        }
        return this.cardTotals.total_other_methods
      }
      // Fallback: calculate from individual payment types
      return fallbackSum
    },
    mergedCategories () {
      const map = new Map(this.topCategories.map(item => [item.id, item]))
      this.modalSelectedCategories.forEach(item => {
        if (item && item.id && !map.has(item.id)) {
          map.set(item.id, item)
        }
      })
      return Array.from(map.values())
    },
    mergedUsers () {
      const map = new Map(this.users.map(item => [item.id, item]))
      // If a user is selected, make sure it's in the list
      if (this.modalSelectedUser && this.modalSelectedUser !== '') {
        const selectedUser = this.users.find(u => String(u.id) === String(this.modalSelectedUser))
        if (selectedUser && !map.has(selectedUser.id)) {
          map.set(selectedUser.id, selectedUser)
        } else if (!selectedUser) {
          const fallbackLabel = this.modalSelectedUserName || this.selected_user_name || ''
          // Keep a synthetic option so el-select shows the label instead of raw ID.
          if (fallbackLabel) {
            map.set(this.modalSelectedUser, {
              id: this.modalSelectedUser,
              firstname: '',
              lastname: '',
              email: fallbackLabel
            })
          }
        }
      }
      return Array.from(map.values())
    },
    unpaidOrdersFilterOptions () {
      return [
        { value: 'all', label: this.$t('general.all') },
        { value: 'paid', label: this.$t('paymentStatus.paid') },
        { value: 'unpaid', label: this.$t('reports.unpaid') }
      ]
    },
    mergedSalesReportTables () {
      const map = new Map((this.availableTables || []).map(t => [t.id, t]))
      if (this.modalSelectedTable && this.modalSelectedTable.id != null && !map.has(this.modalSelectedTable.id)) {
        map.set(this.modalSelectedTable.id, this.modalSelectedTable)
      }
      return Array.from(map.values())
    }
  },
  methods: {
    getUserLabel (user) {
      if (!user) return ''
      return (user.firstname && user.lastname) ? (user.firstname + ' ' + user.lastname) : (user.email || '')
    },
    getSelectedUserDisplayName (userId, cachedName = '') {
      if (cachedName) return cachedName
      const user = (this.mergedUsers || []).find(x => String(x.id) === String(userId)) ||
        (this.users || []).find(x => String(x.id) === String(userId))
      return this.getUserLabel(user) || '-'
    },
    handleUserChange (value) {
      if (!value) {
        this.modalSelectedUserName = ''
      } else {
        const selectedUser = (this.mergedUsers || []).find(u => String(u.id) === String(value))
        this.modalSelectedUserName = this.getUserLabel(selectedUser)
      }
      this.clearUserSearch()
    },
    getLocationName (storeId) {
      if (!storeId) return ''
      const location = this.locations.find(loc => loc.id === storeId)
      return location ? location.name : ''
    },
    syncModalFromFilters () {
      // copy current live filters into modal buffers
      this.modalOrders = {
        valid: Array.isArray(this.orders.valid) ? [...this.orders.valid] : [],
        location: this.orders.location || '',
        search: this.orders.search || '',
        methods: Array.isArray(this.orders.methods) ? [...this.orders.methods] : []
      }
      this.modalValidFrom = this.valid_from
      this.modalValidTo = this.valid_to
      this.modalSelectedDriver = this.selectedDriver
      this.modalSelectedPosUser = this.selectedPosUser
      this.modalSelectedUser = this.selected_user
      this.modalSelectedUserName = this.selected_user_name || this.getSelectedUserDisplayName(this.selected_user)
      this.modalSelectedOrderFrom = this.selected_order_from
      this.modalSelectedPaymentMethods = Array.isArray(this.selected_payment_methods) ? [...this.selected_payment_methods] : []
      this.modalUnpaidOrdersFilter = this.unpaidOrdersFilter || 'paid'
      this.modalSelectedTable = this.selectedTable && this.selectedTable.id != null
        ? { ...this.selectedTable }
        : null
      this.modalOrderId = this.orderId
      this.modalHasReceipt = this.hasRceipt
      this.modalFreeSearch = this.freeSearch
      this.modalZet = this.zet
      this.modalSelectedCategories = Array.isArray(this.selectedCategories) ? [...this.selectedCategories] : []
    },
    searchTopCategories (query) {
      if (!query) {
        return
      }

      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      }

      this.loadingCategories = true
      this.apiRequest('/search-top-categories', 'GET', data, (response) => {
        if (response.status) {
          this.topCategories = response.data
        }
        this.$nextTick(() => {
          this.loadingCategories = false
        })
      })
    },
    clearCategorySearch () {
      if (this.$refs.categorySelect) {
        this.$refs.categorySelect.focus()
        this.$refs.categorySelect.query = ''
        this.$refs.categorySelect.handleQueryChange('')
      }
    },
    getUsers () {
      // Fetch all users on page load
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.loadingUsers = true
      this.apiRequest('/search-users', 'GET', data, (response) => {
        if (response.status === true && response.data) {
          // Handle different response structures
          if (Array.isArray(response.data)) {
            this.users = response.data
          } else if (response.data.users && Array.isArray(response.data.users)) {
            this.users = response.data.users
          } else if (response.data.user && Array.isArray(response.data.user)) {
            this.users = response.data.user
          } else {
            this.users = []
          }
        } else {
          this.users = []
        }
        this.$nextTick(() => {
          this.loadingUsers = false
        })
      })
    },
    searchUsers (query) {
      // Clear any existing timeout
      if (this.userSearchTimeout) {
        clearTimeout(this.userSearchTimeout)
        this.userSearchTimeout = null
      }

      if (!query) {
        this.users = []
        return
      }

      // Debounce the search request
      this.userSearchTimeout = setTimeout(() => {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          search: query
        }

        this.loadingUsers = true
        this.apiRequest('/search-users', 'GET', data, (response) => {
          if (response.status === true && response.data) {
            // Handle different response structures
            if (Array.isArray(response.data)) {
              this.users = response.data
            } else if (response.data.users && Array.isArray(response.data.users)) {
              this.users = response.data.users
            } else if (response.data.user && Array.isArray(response.data.user)) {
              this.users = response.data.user
            } else {
              this.users = []
            }
          } else {
            this.users = []
          }
          this.$nextTick(() => {
            this.loadingUsers = false
          })
        })
      }, 300) // 300ms debounce delay
    },
    searchUsersById (userId) {
      // Search for a specific user by ID to populate the list
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: userId
      }

      this.loadingUsers = true
      this.apiRequest('/search-users', 'GET', data, (response) => {
        let resolvedUser = null
        if (response.status === true && response.data) {
          // Handle different response structures
          if (Array.isArray(response.data)) {
            this.users = response.data
            resolvedUser = this.users.find(u => String(u.id) === String(userId)) || null
          } else if (response.data.users && Array.isArray(response.data.users)) {
            this.users = response.data.users
            resolvedUser = this.users.find(u => String(u.id) === String(userId)) || null
          } else if (response.data.user && Array.isArray(response.data.user)) {
            this.users = response.data.user
            resolvedUser = this.users.find(u => String(u.id) === String(userId)) || null
          } else if (response.data && response.data.id) {
            // Single user object
            this.users = [response.data]
            resolvedUser = String(response.data.id) === String(userId) ? response.data : null
          } else {
            this.users = []
          }
        } else {
          this.users = []
        }
        const resolvedLabel = this.getUserLabel(resolvedUser)
        if (resolvedLabel) {
          if (String(this.selected_user) === String(userId)) {
            this.selected_user_name = resolvedLabel
          }
          if (String(this.modalSelectedUser) === String(userId)) {
            this.modalSelectedUserName = resolvedLabel
          }
        }
        this.$nextTick(() => {
          this.loadingUsers = false
        })
      })
    },
    clearUserSearch () {
      if (this.$refs.userSelect) {
        this.$refs.userSelect.focus()
        this.$refs.userSelect.query = ''
        this.$refs.userSelect.handleQueryChange('')
      }
    },
    searchTables (query) {
      if (!query) {
        return
      }
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      }
      this.loadingTables = true
      this.apiRequest('/search-tables', 'GET', data, response => {
        if (response.status) {
          this.availableTables = response.data || []
        } else {
          this.availableTables = []
        }
        this.$nextTick(() => {
          this.loadingTables = false
        })
      })
    },
    clearTableSearch () {
      const select = this.$refs.salesReportTableSelect
      if (select) {
        select.focus()
        select.query = ''
        select.handleQueryChange('')
      }
    },
    openFiltersModal () {
      this.syncModalFromFilters()
      // If a user is already selected, search for it to populate the list
      if (this.modalSelectedUser && this.modalSelectedUser !== '') {
        // Search for the selected user by ID or name
        this.searchUsersById(this.modalSelectedUser)
      }
      this.isFiltersModalOpen = true
      this.$modal.show('salesReportFiltersModal')
    },
    applyFilters () {
      this.orders.valid = Array.isArray(this.modalOrders.valid) ? [...this.modalOrders.valid] : this.orders.valid
      this.orders.location = this.modalOrders.location
      this.orders.search = this.modalOrders.search
      this.orders.methods = Array.isArray(this.modalOrders.methods) ? [...this.modalOrders.methods] : []

      this.valid_from = this.modalValidFrom || '00:00'
      this.valid_to = this.modalValidTo || '23:59'
      this.selectedDriver = this.modalSelectedDriver || ''
      this.selectedPosUser = this.modalSelectedPosUser || ''
      this.selected_user = this.modalSelectedUser || ''
      this.selected_user_name = this.modalSelectedUser
        ? (this.modalSelectedUserName || this.getSelectedUserDisplayName(this.modalSelectedUser))
        : ''
      this.selected_order_from = this.modalSelectedOrderFrom || ''
      this.selected_payment_methods = Array.isArray(this.modalSelectedPaymentMethods) ? [...this.modalSelectedPaymentMethods] : []
      this.unpaidOrdersFilter = this.modalUnpaidOrdersFilter || 'paid'
      this.selectedTable = this.modalSelectedTable && this.modalSelectedTable.id != null
        ? { ...this.modalSelectedTable }
        : null
      this.orderId = this.modalOrderId || null
      this.zet = this.modalZet || null
      this.selectedCategories = Array.isArray(this.modalSelectedCategories) ? [...this.modalSelectedCategories] : []
      this.hasRceipt = this.modalHasReceipt || null
      this.freeSearch = this.modalFreeSearch || ''

      this.saveFiltersToCookie()
      this.$modal.hide('salesReportFiltersModal')
      this.isFiltersModalOpen = false
      this.$nextTick(() => this.getOrders())
    },
    resetModalFilters () {
      // Reset live filters to defaults and reload data
      this.resetFilters()
      // Keep modal open and reflect the reset values inside it
      this.syncModalFromFilters()
    },
    resetFilters () {
      this.orders.location = ''
      this.orders.search = ''
      this.orders.methods = []
      this.selectedDriver = ''
      this.selectedPosUser = ''
      this.selected_user = ''
      this.selected_user_name = ''
      this.selected_order_from = ''
      this.selected_payment_methods = []
      this.unpaidOrdersFilter = 'paid'
      this.selectedTable = null
      this.availableTables = []
      this.orderId = null
      this.zet = null
      this.selectedCategories = []
      this.hasRceipt = null
      this.freeSearch = ''
      this.valid_from = '05:00'
      this.valid_to = '05:00'
      this.orders.valid = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      this.clearFiltersCookie()
      this.getOrders()
    },
    async clientsExportData () {
      let resp = []
      if (this.orders) {
        try {
          let data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            start_date: this.orders.valid[0] + ' ' + this.valid_from + ':00',
            end_date: this.orders.valid[1] + ' ' + this.valid_to + ':00',
            date_column: this.date_column,
            driver: this.selectedDriver,
            operator: this.selectedPosUser,
            selected_user: this.selected_user,
            selected_order_from: this.selected_order_from,
            selected_payment_methods: this.getPaymentMethodsArray(),
            coupon: this.orders.search,
            zet: this.zet,
            top_category_ids: Array.isArray(this.selectedCategories) && this.selectedCategories.length
              ? this.selectedCategories.map(cat => (typeof cat === 'object' && cat !== null ? cat.id : cat))
              : null
          }

          let $dd = {}
          const sortOptions = {
            field: this.sortBy,
            order: this.sortOrder
          }
          data = {
            ...data,
            ...sortOptions
          }

          if (this.orders.location && this.orders.location !== '') {
            data.location_id = this.orders.location
          }

          const unpaidOrdersVal = this.getUnpaidOrdersApiValue()
          if (unpaidOrdersVal !== undefined) {
            data.unpaid_orders = unpaidOrdersVal
          }
          if (this.selectedTable && this.selectedTable.id != null && this.selectedTable.id !== '') {
            data.table_id = this.selectedTable.id
          }

          let ced = []
          let salesData = []
          resp = await new Promise((resolve, reject) => {
            const ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : ''
            this.apiRequest('/reports/sales-report-export-excel' + ver + '?withProducts=1&page=' + 1 + '&pageSize=' + 50000, 'GET', data, response => {
              // Handle multiple possible response structures
              if (response.status === true && response.data) {
                // New structure: { status: true, data: { export_excel: [...] } }
                if (response.data.export_excel && Array.isArray(response.data.export_excel)) {
                  salesData = response.data.export_excel
                } else if (response.data.orders && response.data.orders.data) {
                  // Old structure: { data: { orders: { data: [...] } } }
                  salesData = response.data.orders.data
                } else if (Array.isArray(response.data)) {
                  // Flat array fallback: { data: [...] }
                  salesData = response.data
                } else {
                  salesData = []
                }

                if (salesData && salesData.length > 0) {
                  for (const sale of salesData) {
                    // Support both old and new field names
                    $dd = {
                      location: sale.location || this.getLocationName(sale.store_id) || '',
                      date: sale.date || sale.created_at,
                      updated_at: sale.updated_at,
                      order: sale.order || sale.token,
                      number: sale.number,
                      deliveryType: sale.deliveryType || sale.delivery_type,
                      name: sale.name || (sale.customer ? (sale.customer.firstname + ' ' + sale.customer.lastname) : ''),
                      phone: sale.phone || (sale.customer ? sale.customer.phone : ''),
                      totalAmount: sale.totalAmount !== undefined ? sale.totalAmount : sale.totals_grandtotal,
                      totalDiscount: sale.totalDiscount !== undefined
                        ? sale.totalDiscount
                        : (sale.totals_discount + sale.totals_discount_loyalty_points),
                      totalTax: sale.totalTax !== undefined ? sale.totalTax : sale.totals_extras,
                      totalDelivery: sale.totalDelivery !== undefined ? sale.totalDelivery : sale.totals_delivery,
                      zone: sale.zone || (sale.shipping_details ? sale.shipping_details.name : ''),
                      paymentType: sale.paymentType || sale.payment_type,
                      orderProducts: sale.orderProducts,
                      orderAdress: sale.orderAdress,
                      orderComments: sale.orderComments,
                      receiptNumber: sale.receiptNumber
                    }
                    ced.push($dd)
                  }
                }
              } else {
                // Avoid leaving the loader on if API returns an error payload
                console.error('Failed to export sales report:', response && response.errors ? response.errors : response)
              }
              resolve(ced)
            })
          })
          return resp
        } catch (e) {
          console.error('Unexpected error while exporting sales report:', e)
          return []
        } finally {
          // Safety: always clear export loading state when export request finishes
          this.finishDownload()
        }
      }
    },
    startDownload () {
      this.exportLoading = true
    },
    finishDownload () {
      this.exportLoading = false
    },
    changeValidFrom (fields = 'valid_order') {
      // if (this.valid_to <= this.valid_from) {
      //   this.valid_to = '23:59'
      // }
      if (fields === 'valid_order') {
        if (!this.valid_from) {
          this.valid_from = '00:00'
        }
        if (!this.valid_to) {
          this.valid_to = '23:59'
        }
      } else {
        if (!this.products_valid_from) {
          this.products_valid_from = '00:00'
        }
        if (!this.products_valid_to) {
          this.products_valid_to = '23:59'
        }
      }
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details
      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }
        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }
      if (this.locations.length > 1) {
        this.showLocations = true
      }
      // Location filter is now loaded in loadFiltersFromCookie()
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    isUnpaidSelected () {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return false
      }
      // Handle both string IDs and objects
      return this.selected_payment_methods.some(method => {
        const id = typeof method === 'string' ? method : (method && method.id)
        return id === 'unpaid'
      })
    },
    /**
     * unpaid_orders: 1 → payment_type null only; 0 → payment_type not null.
     * undefined → omit param (all orders). Selecting "unpaid" in payment methods forces 1.
     */
    getUnpaidOrdersApiValue () {
      if (this.isUnpaidSelected()) {
        return 1
      }
      if (this.unpaidOrdersFilter === 'unpaid') {
        return 1
      }
      if (this.unpaidOrdersFilter === 'paid') {
        return 0
      }
      return undefined
    },
    getPaymentMethodsArray () {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return []
      }
      // Extract IDs from array, filter out 'unpaid', and ensure we only have strings
      return this.selected_payment_methods
        .map(method => {
          // If it's already a string, use it; otherwise extract the id
          return typeof method === 'string' ? method : (method && method.id ? method.id : null)
        })
        .filter(method => method && method !== 'unpaid') // Remove null/undefined and 'unpaid'
    },
    getPaymentMethods () {
      let sessionData = this.$session.get('selectedCompanyData')

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/orders/get-payment-methods', 'GET', data, (response) => {
          if (response.status && response.data.length) {
            let result = response.data.map(item => {
              return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
            })
            // Add voucher to payment methods
            if (!result.find(item => item.id === 'VOUCHER')) {
              result.push({id: 'VOUCHER', name: this.$t('paymentTypes.VOUCHER')})
            }
            sessionData['payment_methods'] = response.data
            this.$session.set('selectedCompanyData', sessionData)

            Vue.set(this, 'paymentMethods', result)
          }
        })
      } else {
        let result = sessionData['payment_methods'].map(item => {
          return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
        })
        // Add voucher to payment methods
        if (!result.find(item => item.id === 'VOUCHER')) {
          result.push({id: 'VOUCHER', name: this.$t('paymentTypes.VOUCHER')})
        }
        Vue.set(this, 'paymentMethods', result)
      }
    },
    getOrders (query) {
      if (!this.isReports) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      if (!this.products_valid_from) {
        this.products_valid_from = '00:00'
      }
      if (!this.products_valid_to || this.products_valid_to === '24:00') {
        this.products_valid_to = '23:59'
      }

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        start_date: this.orders.valid[0] + ' ' + this.valid_from + ':00',
        end_date: this.orders.valid[1] + ' ' + this.valid_to + ':00',
        start_date_products: this.orders.valid[0] + ' ' + this.products_valid_from + ':00',
        end_date_products: this.orders.valid[1] + ' ' + this.products_valid_to + ':00',
        date_column: this.date_column,
        driver: this.selectedDriver,
        operator: this.selectedPosUser,
        selected_user: this.selected_user,
        selected_order_from: this.selected_order_from,
        selected_payment_methods: this.getPaymentMethodsArray(),
        coupon: this.orders.search,
        search: this.freeSearch,
        zet: this.zet,
        top_category_ids: Array.isArray(this.selectedCategories) && this.selectedCategories.length
          ? this.selectedCategories.map(cat => (typeof cat === 'object' && cat !== null ? cat.id : cat))
          : null
      }

      const unpaidOrdersVal = this.getUnpaidOrdersApiValue()
      if (unpaidOrdersVal !== undefined) {
        data.unpaid_orders = unpaidOrdersVal
      }

      if (this.orderId) {
        data.order_id = this.orderId
      }
      if (this.selectedTable && this.selectedTable.id != null && this.selectedTable.id !== '') {
        data.table_id = this.selectedTable.id
      }
      // if (valid_from == '24:00') {
      //   valid_from = '23:59'
      // }
      // temporary suspended
      // if (query && query.type === 'sort') {
      //   const sortOptions = {
      //     field: query.sort.prop,
      //     order: query.sort.order
      //   }
      //   data = {
      //     ...data,
      //     ...sortOptions
      //   }
      // }
      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }
      if (this.orders.method && this.orders.method !== '') {
        data.method = this.orders.method.toUpperCase()
      }
      if (this.orders.methods && this.orders.methods.length) {
        data.methods = this.orders.methods
          .filter(m => m != null)
          .map(method => {
            if (typeof method === 'string') {
              return method.toUpperCase()
            }
            const key = method.key || method.value || method
            return String(key).toUpperCase()
          })
      }
      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      const ver = this.$route.query && this.$route.query.ver === 'V2' ? 'V2' : ''
      const hasReceiptValue = (this.hasRceipt && this.hasRceipt.value) || null

      this.apiRequest('/reports/sales-report' + ver + '?page=' + page + '&pageSize=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, response => {
        if (response.status === true) {
          // this.drivers = response.data.drivers
          // Populate users from API response if available and not already populated
          if (response.data.users && (!this.users || this.users.length === 0)) {
            this.users = Array.isArray(response.data.users) ? response.data.users : []
          }
          this.ordersTableData = response.data.orders
          this.totals.totalTips = response.data.payment_tips || 0
          this.totals.totalCash = response.data.payment_cash || 0
          this.totals.totalVirament = response.data.payment_virament || 0
          this.totals.totalOnline = response.data.payment_online || 0
          this.totals.totalProtocol = response.data.payment_protocol || 0
          this.totals.totalStaffFood = response.data.payment_staff_food || 0
          this.totals.totalRoom = response.data.payment_room || 0
          this.totals.totalEvent = response.data.payment_event || 0
          this.totals.totalFolio = response.data.payment_folio || 0
          this.totals.totalSplit = response.data.payment_split || 0
          this.totals.totalCard = response.data.payment_card || 0
          this.totals.totalPOS = response.data.payment_pos || 0
          this.totals.totalCARDPOS = response.data.payment_card_pos || 0
          this.totals.totalDiscount = response.data.total_discount || 0
          this.totals.totalDiscountItems = response.data.total_discount_items || 0
          this.totals.totalDiscountLoyaltyPoints = response.data.total_discount_loyalty_points || 0
          this.totals.totalTax = response.data.total_tax || 0
          this.totals.totalSlotTax = response.data.total_slot_tax || 0
          this.totals.totalSlotPartTax = response.data.total_slot_part_tax || 0
          this.totals.avarageOrderValue = response.data.avarage_order_value || 0
          this.totals.totalShipping = response.data.total_shipping
          this.totals.totalBoltCard = response.data.payment_bolt_card || 0
          this.totals.totalBoltCash = response.data.payment_bolt_cash || 0
          this.totals.totalGlovoCard = response.data.payment_glovo_card || 0
          this.totals.totalGlovoCash = response.data.payment_glovo_cash || 0
          this.totals.totalWoltCard = response.data.payment_wolt_card || response.data.payment_woltCard || 0
          this.totals.totalWoltCash = response.data.payment_wolt_cash || response.data.payment_woltCash || 0
          this.totals.totalWoltOtherMethods = response.data.payment_wolt_other_methods || 0
          this.totals.totalPayFromWallet = response.data.total_pay_from_wallet || 0
          this.totals.totalSplitCash = response.data.total_split_cash || 0
          this.totals.totalSplitCard = response.data.total_split_card || 0
          this.totals.totalSplitVoucher = response.data.total_split_voucher || 0
          this.totals.totalUnpaid = response.data.payment_unpaid || 0
          this.totals.unfiscalTotal = response.data.unfiscal_total || 0
          this.totals.unfiscalTotalCard = response.data.unfiscal_total_card || 0
          this.totals.unfiscalTotalCash = response.data.unfiscal_total_cash || 0
          this.totals.unfiscalTotalCredit = response.data.unfiscal_total_credit || 0
          this.totals.unfiscalTotalOnline = response.data.unfiscal_total_online || 0
          const giftCardsSold = response.data.gift_cards_sold
          if (giftCardsSold && typeof giftCardsSold === 'object') {
            this.totals.giftCardsSoldCount = giftCardsSold.count != null ? (Number(giftCardsSold.count) || 0) : 0
            this.totals.giftCardsSoldAmount = giftCardsSold.amount != null ? (Number(giftCardsSold.amount) || 0) : 0
          } else {
            this.totals.giftCardsSoldCount = 0
            this.totals.giftCardsSoldAmount = 0
          }

          // Store card_totals from API response
          if (response.data.card_totals) {
            this.cardTotals = {
              total_amount: response.data.card_totals.total_amount || 0,
              total_cash: response.data.card_totals.total_cash || 0,
              total_online: response.data.card_totals.total_online || 0,
              total_card: response.data.card_totals.total_card || 0,
              total_credit: response.data.card_totals.total_credit || 0,
              total_other_methods: response.data.card_totals.total_other_methods || 0
            }
          }

          // Use card_totals.total_amount from API, or fallback to other fields
          const apiTotal = (response.data.card_totals && response.data.card_totals.total_amount) ||
                          response.data.total_sales ||
                          response.data.grand_total ||
                          response.data.total_grandtotal
          if (apiTotal !== undefined && apiTotal !== null) {
            this.totals.total = parseFloat(apiTotal) || 0
          } else {
            // Fallback: calculate from payment methods if API doesn't provide total
            this.totals.total =
              (this.cashSummaryTotal || 0) +
              (this.totalOnlineSummaryTotal || 0) +
              (this.totalCardSummaryTotal || 0) +
              (this.totalCreditSummaryTotal || 0) +
              (this.nonFiscalSummaryTotal || 0) +
              (this.totals.totalUnpaid || 0) +
              (this.totals.giftCardsSoldAmount || 0)
          }

          // Include gift cards sold amount in the headline total (first card).
          this.totals.total = (Number(this.totals.total) || 0) + (Number(this.totals.giftCardsSoldAmount) || 0)

          // Handle both response.data.orders.total and response.data.total_orders
          this.totalOrders = response.data.orders.total || response.data.total_orders || 0
          this.json_data = response.data.export_excel

          const cardPayment = response.data.payment_card_counter
          const cashPayment = response.data.payment_cash_counter
          const viramentPayment = response.data.payment_virament_counter
          const onlinePayment = response.data.payment_online_counter
          const protocolPayment = response.data.payment_protocol_counter
          const paymentStaffFoodPayment = response.data.payment_staff_food_counter
          const paymentRoomPayment = response.data.payment_room_counter
          const paymentEventPayment = response.data.payment_event_counter
          const paymentFolioPayment = response.data.payment_folio_counter
          const paymentSplitPayment = response.data.payment_split_counter
          const posPayment = response.data.payment_pos_counter
          const cardPosPayment = response.data.payment_card_pos_counter
          const boltCardPayment = response.data.payment_bolt_card_counter
          const boltCashPayment = response.data.payment_bolt_cash_counter
          const glovoCardPayment = response.data.payment_glovo_card_counter
          const glovoCashPayment = response.data.payment_glovo_cash_counter
          const woltCardPayment = response.data.payment_wolt_card_counter
          const woltCashPayment = response.data.payment_wolt_cash_counter
          const woltOtherMethodsPayment = response.data.payment_wolt_other_methods_counter
          const unpaidPayment = response.data.payment_unpaid_counter

          let totalPayments = cardPayment + cashPayment + posPayment + cardPosPayment + viramentPayment + onlinePayment + protocolPayment + paymentStaffFoodPayment + paymentRoomPayment + paymentEventPayment + paymentFolioPayment + paymentSplitPayment + boltCardPayment + boltCashPayment + glovoCardPayment + glovoCashPayment + woltCardPayment + woltCashPayment + (woltOtherMethodsPayment || 0) + unpaidPayment
          if (totalPayments) {
            this.salesReportChart.data.labels = [
              this.$t('reports.card') + ' - ' + parseFloat(cardPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.cash') + ' - ' + parseFloat(cashPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.pos') + ' - ' + parseFloat(posPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.cardPos') + ' - ' + parseFloat(cardPosPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.virament') + ' - ' + parseFloat(viramentPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.online') + ' - ' + parseFloat(onlinePayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.protocol') + ' - ' + parseFloat(protocolPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.staffFood') + ' - ' + parseFloat(paymentStaffFoodPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.room') + ' - ' + parseFloat(paymentRoomPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.event') + ' - ' + parseFloat(paymentEventPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.folio') + ' - ' + parseFloat(paymentFolioPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('paymentTypes.SPLIT') + ' - ' + parseFloat(paymentSplitPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.boltCard') + ' - ' + parseFloat(boltCardPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.boltCash') + ' - ' + parseFloat(boltCashPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.glovoCard') + ' - ' + parseFloat(glovoCardPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.glovoCash') + ' - ' + parseFloat(glovoCashPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.woltCard') + ' - ' + parseFloat(woltCardPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.woltCash') + ' - ' + parseFloat(woltCashPayment * 100 / totalPayments).toFixed(2) + '%',
              this.$t('reports.woltOtherMethods') + ' - ' + parseFloat((woltOtherMethodsPayment || 0) * 100 / totalPayments).toFixed(2) + '%'
            ]
            this.salesReportChart.data.series = [
              {
                value: cardPayment,
                name: this.$t('reports.card')
              },
              {
                value: cashPayment,
                name: this.$t('reports.cash')
              },
              {
                value: posPayment,
                name: this.$t('reports.pos')
              },
              {
                value: cardPosPayment,
                name: this.$t('reports.cardPos')
              },
              {
                value: viramentPayment,
                name: this.$t('reports.virament')
              },
              {
                value: onlinePayment,
                name: this.$t('reports.online')
              },
              {
                value: protocolPayment,
                name: this.$t('reports.protocol')
              },
              {
                value: paymentStaffFoodPayment,
                name: this.$t('reports.staffFood')
              },
              {
                value: paymentRoomPayment,
                name: this.$t('reports.room')
              },
              {
                value: paymentEventPayment,
                name: this.$t('reports.event')
              },
              {
                value: paymentFolioPayment,
                name: this.$t('reports.folio')
              },
              {
                value: paymentSplitPayment,
                name: this.$t('paymentTypes.SPLIT')
              },
              {
                value: boltCardPayment,
                name: this.$t('reports.boltCard')
              },
              {
                value: boltCashPayment,
                name: this.$t('reports.boltCash')
              },
              {
                value: glovoCardPayment,
                name: this.$t('reports.glovoCard')
              },
              {
                value: glovoCashPayment,
                name: this.$t('reports.glovoCash')
              },
              {
                value: woltCardPayment,
                name: this.$t('reports.woltCard')
              },
              {
                value: woltCashPayment,
                name: this.$t('reports.woltCash')
              },
              {
                value: (woltOtherMethodsPayment || 0),
                name: this.$t('reports.woltOtherMethods')
              }
            ]
            this.$refs.salesReportChart.initChart()
          } else {
            this.salesReportChart.data.labels = [
              this.$t('reports.card') + ' - ' + 0,
              this.$t('reports.cash') + ' - ' + 0,
              this.$t('reports.pos') + ' - ' + 0,
              this.$t('reports.cardPos') + ' - ' + 0,
              this.$t('reports.virament') + ' - ' + 0,
              this.$t('reports.online') + ' - ' + 0,
              this.$t('reports.protocol') + ' - ' + 0,
              this.$t('reports.room') + ' - ' + 0,
              this.$t('reports.event') + ' - ' + 0,
              this.$t('reports.folio') + ' - ' + 0,
              this.$t('paymentTypes.SPLIT') + ' - ' + 0,
              this.$t('reports.boltCard') + ' - ' + 0,
              this.$t('reports.boltCash') + ' - ' + 0,
              this.$t('reports.glovoCard') + ' - ' + 0,
              this.$t('reports.glovoCash') + ' - ' + 0,
              this.$t('reports.woltCard') + ' - ' + 0,
              this.$t('reports.woltCash') + ' - ' + 0,
              this.$t('reports.woltOtherMethods') + ' - ' + 0
            ]

            this.salesReportChart.data.series = [
              {
                value: 0,
                name: this.$t('reports.card')
              },
              {
                value: 0,
                name: this.$t('reports.cash')
              },
              {
                value: 0,
                name: this.$t('reports.pos')
              },
              {
                value: 0,
                name: this.$t('reports.cardPos')
              },
              {
                value: 0,
                name: this.$t('reports.virament')
              },
              {
                value: 0,
                name: this.$t('reports.online')
              },
              {
                value: 0,
                name: this.$t('reports.protocol')
              },
              {
                value: 0,
                name: this.$t('reports.room')
              },
              {
                value: 0,
                name: this.$t('reports.event')
              },
              {
                value: 0,
                name: this.$t('reports.folio')
              },
              {
                value: 0,
                name: this.$t('paymentTypes.SPLIT')
              },
              {
                value: 0,
                name: this.$t('reports.boltCard')
              },
              {
                value: 0,
                name: this.$t('reports.boltCash')
              },
              {
                value: 0,
                name: this.$t('reports.glovoCard')
              },
              {
                value: 0,
                name: this.$t('reports.glovoCash')
              },
              {
                value: 0,
                name: this.$t('reports.woltCard')
              },
              {
                value: 0,
                name: this.$t('reports.woltCash')
              },
              {
                value: 0,
                name: this.$t('reports.woltOtherMethods')
              }
            ]
            this.$refs.salesReportChart.initChart()
          }
          // this.salesReportChart.data.series.push({value: cardPayment, name: this.$t('reports.card')})
          // this.salesReportChart.data.series.push({value: cashPayment, name: this.$t('reports.cash')})
          // this.$refs.salesReportChart.initChart()
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.saveFiltersToCookie()
      this.getOrders()
    },
    goToRecordOrder (row, event, column) {
      this.$router.push('/orders/view/' + row.id)
    },
    formatReceiptNumber (receiptNumber) {
      if (!receiptNumber) {
        return '-'
      }

      try {
        // If it's already an object
        if (typeof receiptNumber === 'object' && receiptNumber !== null) {
          return receiptNumber.ReceiptNumber || receiptNumber.receiptNumber || receiptNumber.receipt_number || JSON.stringify(receiptNumber)
        }

        // If it's a string, try to parse it
        if (typeof receiptNumber === 'string') {
          if (!receiptNumber.trim()) {
            return '-'
          }
          const parsed = JSON.parse(receiptNumber)
          if (typeof parsed === 'object' && parsed !== null) {
            return parsed.ReceiptNumber || parsed.receiptNumber || parsed.receipt_number || receiptNumber
          }
          return parsed
        }

        return receiptNumber
      } catch (e) {
        // If parsing fails, return the original value
        return receiptNumber
      }
    },
    parseZet (receiptNumber) {
      if (!receiptNumber) {
        return '-'
      }

      try {
        let data = receiptNumber

        // If it's a JSON string, parse it
        if (typeof data === 'string') {
          if (!data.trim()) {
            return '-'
          }
          data = JSON.parse(data)
        }

        // Now expect an object
        if (typeof data === 'object' && data !== null) {
          const info =
            data.ReceiptInfo ||
            data.receiptInfo ||
            data.receipt_info ||
            ''

          if (typeof info === 'string') {
            // Try to extract NRZ=<number>
            const match = info.match(/NRZ\s*=\s*(\d+)/)
            if (match && match[1]) {
              return match[1]
            }
          }
        }

        return '-'
      } catch (e) {
        return '-'
      }
    },
    saveFiltersToCookie () {
      const filters = {
        location: this.orders.location || '',
        valid: this.orders.valid || [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        valid_from: this.valid_from || '05:00',
        valid_to: this.valid_to || '05:00',
        methods: Array.isArray(this.orders.methods) ? this.orders.methods : [],
        search: this.orders.search || '',
        selected_user: this.selected_user || '',
        selected_user_name: this.selected_user_name || '',
        selectedPosUser: this.selectedPosUser || '',
        selected_order_from: this.selected_order_from || '',
        selected_payment_methods: Array.isArray(this.selected_payment_methods) ? this.selected_payment_methods : [],
        unpaidOrdersFilter: this.unpaidOrdersFilter || 'paid',
        selectedTable: this.selectedTable && this.selectedTable.id != null
          ? { id: this.selectedTable.id, label: this.selectedTable.label || '' }
          : null,
        orderId: this.orderId || null,
        zet: this.zet || null,
        selectedCategories: Array.isArray(this.selectedCategories) ? this.selectedCategories : [],
        hasRceipt: this.hasRceipt || null,
        freeSearch: this.freeSearch || '',
        selectedDriver: this.selectedDriver || ''
      }
      this.$cookie.set('sales-report-filters', JSON.stringify(filters), 30)
      // Keep backward compatibility with filter-locations
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    loadFiltersFromCookie () {
      const filtersCookie = this.$cookie.get('sales-report-filters')
      if (filtersCookie) {
        try {
          const filters = JSON.parse(filtersCookie)

          if (filters.location !== undefined) {
            this.orders.location = filters.location || ''
          }
          if (filters.valid && Array.isArray(filters.valid) && filters.valid.length === 2) {
            this.orders.valid = filters.valid
          }
          if (filters.valid_from) {
            this.valid_from = filters.valid_from
          }
          if (filters.valid_to) {
            this.valid_to = filters.valid_to
          }
          if (filters.methods && Array.isArray(filters.methods)) {
            this.orders.methods = filters.methods
          }
          if (filters.search !== undefined) {
            this.orders.search = filters.search || ''
          }
          if (filters.selected_user !== undefined) {
            this.selected_user = filters.selected_user || ''
          }
          if (filters.selected_user_name !== undefined) {
            this.selected_user_name = filters.selected_user_name || ''
          }
          if (filters.selectedPosUser !== undefined) {
            this.selectedPosUser = filters.selectedPosUser || ''
          }
          if (filters.selected_order_from !== undefined) {
            this.selected_order_from = filters.selected_order_from || ''
          }
          if (filters.selected_payment_methods && Array.isArray(filters.selected_payment_methods)) {
            this.selected_payment_methods = filters.selected_payment_methods
          }
          if (filters.unpaidOrdersFilter === 'all' || filters.unpaidOrdersFilter === 'paid' || filters.unpaidOrdersFilter === 'unpaid') {
            this.unpaidOrdersFilter = filters.unpaidOrdersFilter
          }
          if (filters.selectedTable && filters.selectedTable.id != null) {
            this.selectedTable = {
              id: filters.selectedTable.id,
              label: filters.selectedTable.label || String(filters.selectedTable.id)
            }
          } else if (filters.selectedTable === null) {
            this.selectedTable = null
          }
          if (filters.orderId !== undefined) {
            this.orderId = filters.orderId || null
          }
          if (filters.zet !== undefined) {
            this.zet = filters.zet || null
          }
          if (filters.selectedCategories && Array.isArray(filters.selectedCategories)) {
            this.selectedCategories = filters.selectedCategories
          }
          if (filters.hasRceipt !== undefined) {
            this.hasRceipt = filters.hasRceipt || null
          }
          if (filters.freeSearch !== undefined) {
            this.freeSearch = filters.freeSearch || ''
          }
          if (filters.selectedDriver !== undefined) {
            this.selectedDriver = filters.selectedDriver || ''
          }

          // If a user is selected, fetch it if not already in the list
          if (this.selected_user && this.selected_user !== '') {
            const userExists = this.users.find(u => String(u.id) === String(this.selected_user))
            if (!userExists) {
              this.searchUsersById(this.selected_user)
            }
          }

          // Load data with restored filters only if component is active
          if (this.isReports) {
            this.$nextTick(() => {
              this.getOrders()
            })
          }
        } catch (e) {
          console.error('Error loading filters from cookie:', e)
        }
      } else {
        // Fallback to old filter-locations cookie for backward compatibility
        const filterCookie = this.$cookie.get('filter-locations')
        if (filterCookie) {
          try {
            const filterCookieParsed = JSON.parse(filterCookie)
            if (filterCookieParsed && filterCookieParsed[0]) {
              this.orders.location = filterCookieParsed[0]
            }
          } catch (e) {
            console.error('Error loading old filter-locations cookie:', e)
          }
        }
      }
    },
    clearFiltersCookie () {
      this.$cookie.delete('sales-report-filters')
      this.$cookie.set('filter-locations', JSON.stringify(['']), 30)
    },
    daysBetween (date1, date2) {
      var oneDay = 1000 * 60 * 60 * 24
      var date1Ms = date1.getTime()
      var date2Ms = date2.getTime()
      var differenceMs = date2Ms - date1Ms
      return Math.round(differenceMs / oneDay)
    },
    firstDayofMonth () {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
      return firstDay
    },
    lastDayofMonth () {
      var date = new Date()
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return lastDay
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    tabClicked (selectedTab) {
      // console.warn('test')
      // console.warn('Current tab re-clicked:' + selectedTab.tab.title)
    },
    tabChanged (selectedTab) {
      // console.warn('Tab changed to:' + selectedTab.tab.title)
    },
    getPosUsers () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response.status) {
          this.posUsers = response.data.pos_user
        }
      })
    },
    getDrivers () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/reports/drivers-list', 'GET', data, (response) => {
        if (response.status) {
          this.drivers = response.data.drivers || response.data || []
        }
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }

  .centered-cell .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sales-toolbar-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    min-height: 40px;
  }

  .filter-btn {
    display: inline-block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .filters-applied-row {
    margin-top: 10px;
    font-size: 13px;
    text-align: left;
  }

  .filters-applied-label {
    font-weight: 600;
    margin-right: 6px;
    color: #25396F;
  }

  .filter-selection {
    display: inline-flex;
    align-items: center;
    background: #F4F6FF;
    border: 1px solid #E4E7FF;
    color: #25396F;
    border-radius: 10px;
    padding: 4px 10px;
    margin-right: 6px;
    margin-bottom: 6px;
  }

  .reset-filters-link {
    margin-left: 8px;
    font-weight: 600;
  }

  .sales-summary-card {
    background: #FBFCFF;
    border: 1px solid #E6E9FF;
    border-radius: 12px;
    padding: 16px;
    min-height: 280px;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(18, 38, 63, 0.04);
  }

  .sales-summary-card.primary {
    border: 2px solid #3B4BFF;
  }

  .sales-summary-title {
    font-weight: 700;
    color: #25396F;
    font-size: 14px;
  }

  .sales-summary-total {
    font-weight: 800;
    color: #25396F;
    font-size: 22px;
    margin-top: 6px;
    margin-bottom: 10px;
  }

  .sales-summary-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
  }

  .summary-cards-row {
    display: flex;
    flex-wrap: wrap;
  }

  .summary-cards-row > [class*="col-"] {
    display: flex;
    flex-direction: column;
  }

  .sales-summary-item {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #25396F;
    opacity: 0.9;
  }

  .sales-summary-group-title {
    margin-top: 8px;
    margin-bottom: 4px;
    font-weight: 700;
    font-size: 12px;
    color: #25396F;
    text-transform: uppercase;
    letter-spacing: 0.2px;
  }

  .date-time-row {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .sales-date-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin: 10px 0 15px;
  }

  .sales-date-label {
    margin: 0;
    font-weight: 500;
    color: #25396F;
  }

  .sales-date-picker {
    min-width: 260px;
  }

  .sales-time-range {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .sales-date-text {
    margin: 0 4px;
    font-size: 13px;
    color: #25396F;
  }

  /*
   * Sales report filter modal: same DOM as Orders.vue filtersAndSortModal.
   * Extra class `sales-report-filters` is on vue-js-modal’s .vm--container (see library).
   * Column scroll + card padding come from Orders.vue .filtersAndSortModal when that chunk is loaded.
   */
  .vm--container.sales-report-filters {
    max-width: 100%;
    overflow-x: hidden;
  }

  .vm--container.sales-report-filters .filters-grid.sales-report-filters-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 0;
  }

  .vm--container.sales-report-filters .modal-column-left,
  .vm--container.sales-report-filters .modal-column-right {
    padding: 0 10px;
  }

  .vm--container.sales-report-filters .filter-section {
    margin-bottom: 12px;
    padding: 0;
    width: 100%;
  }

  .vm--container.sales-report-filters .filters-grid.sales-report-filters-grid .wide-filter {
    grid-column: 1 / 3;
  }

  .vm--container.sales-report-filters .filter-section h6 {
    margin-bottom: 5px;
    font-size: 13px;
    font-weight: 500;
  }

  .vm--container.sales-report-filters .modal-header {
    padding: 10px 15px !important;
    margin-bottom: 10px;
  }

  .vm--container.sales-report-filters .modal-header h4 {
    margin: 0;
    font-size: 16px;
  }

  .vm--container.sales-report-filters .modal-footer.slim-footer {
    text-align: right;
    margin-top: 8px;
    border-top: 1px solid #eee;
    padding-top: 6px;
    padding-bottom: 0 !important;
    padding-left: 15px !important;
    padding-right: 0 !important;
  }

  .vm--container.sales-report-filters .slim-footer .el-button {
    font-size: 14px;
  }

  .vm--container.sales-report-filters .form-control,
  .vm--container.sales-report-filters .el-input__inner,
  .vm--container.sales-report-filters .el-input {
    padding: 6px 10px;
    font-size: 13px;
  }

  .vm--container.sales-report-filters .el-select {
    width: 100% !important;
  }

  .vm--container.sales-report-filters .el-select .el-input {
    width: 100% !important;
  }

  .vm--container.sales-report-filters .el-select .el-input__inner {
    width: 100% !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .vm--container.sales-report-filters .el-select__tags {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
  }

  .vm--container.sales-report-filters .v-select {
    width: 100% !important;
  }

  .vm--container.sales-report-filters .vm--modal {
    border-radius: 6px;
    overflow: hidden !important;
    box-sizing: border-box;
  }

  .vm--container.scrollable.sales-report-filters .vm--modal {
    margin-bottom: 0 !important;
  }

  .vm--container.sales-report-filters .vm--modal .card {
    margin-bottom: 0 !important;
    border-radius: 0;
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ReportsSales.vue